import styled from "styled-components";
import { BARE_BUTTON_ICON_SIZE } from "../button-icon/ButtonIcon.style";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
import { apolloSpaceInset1X, apolloSpaceInset2X } from "@nexthink/apollo-tokens";
export const GROUPING_CELL_WIDTH = BARE_BUTTON_ICON_SIZE + 2 * getValueFromPixelString(apolloSpaceInset1X);
export const GROUPING_CELL_WITH_SELECTION_WIDTH = BARE_BUTTON_ICON_SIZE + getValueFromPixelString(apolloSpaceInset1X);
const GROUPING_CELL_SEPARATOR_WIDTH = 2;
export const StyledTableCellGroupingParent = styled.div.withConfig({ displayName: "StyledTableCellGroupingParent_APC-7281-productShell", componentId: "sc-i0gj6s" })({
    height: BARE_BUTTON_ICON_SIZE,
    display: "flex",
    justifyContent: "flex-start",
});
export const StyledTableCellGroupingChild = styled.div.withConfig({ displayName: "StyledTableCellGroupingChild_APC-7281-productShell", componentId: "sc-sl7fr0" })(({ theme }) => ({
    position: "absolute",
    left: 0,
    width: `${getValueFromPixelString(apolloSpaceInset2X) - GROUPING_CELL_SEPARATOR_WIDTH / 2}px`,
    top: 0,
    bottom: 0,
    backgroundColor: theme.colors.apolloColorBackgroundTableCellDefault,
    borderRight: `${GROUPING_CELL_SEPARATOR_WIDTH}px solid ${theme.colors.apolloColorStrokeSeparator}`,
}));
//# sourceMappingURL=TableGroupingColumn.style.js.map